import codewars from "../../assets/img/challenge/codewars.webp";
import topcoder from "../../assets/img/challenge/topcoder.webp";
import codingame from "../../assets/img/challenge/codingame.webp";
import hackerrank from "../../assets/img/challenge/hackerrank.webp";
import coderbyte from "../../assets/img/challenge/coderbyte.webp";
import codechef from "../../assets/img/challenge/codechef.webp";
import exercism from "../../assets/img/challenge/exercism.webp";
import spoj from "../../assets/img/challenge/spoj.webp";

export const DataChallenge = [
  {
    title: "Codewars",
    path: "https://www.codewars.com/",
    cName: "icon",
    icon: codewars,
    description:
      "Achieve mastery through challenge, Improve your skills by training with others on real code challenges. It's a good website if you want to learn or o upgrade your level with fun challenges.",
  },
  {
    title: "Topcoder",
    path: "https://www.topcoder.com/",
    cName: "icon",
    icon: topcoder,
    description:
      "A good way to show your skills, you just have to configure your projects, launch it and leave the copilot helping you.",
  },
  {
    title: "Codingame",
    path: "https://www.codingame.com/",
    cName: "icon",
    icon: codingame,
    description:
      "Become a better Programmer, upgrade your skills and be visible by the community. If you like to play games, you will love it. It has 25+ programming language to play with and to learn.",
  },
  {
    title: "HackerRank",
    path: "https://www.hackerrank.com/",
    cName: "icon",
    icon: hackerrank,
    description:
      "Join over 11+ million developers, practice coding skills, prepare for interviews and get hired. Also, it's a platform for companies who want to hire the developers they want.",
  },
  {
    title: "Coderbyte",
    path: "https://coderbyte.com/",
    cName: "icon",
    icon: coderbyte,
    description:
      "Level up your coding and interview skills. It's a good platform with more than 300+ challenges.",
  },
  {
    title: "CodeChef",
    path: "https://www.codechef.com/",
    cName: "icon",
    icon: codechef,
    description:
      "Learn competitive programming with CodeChef from World-Class Programmers.",
  },
  {
    title: "Exercism",
    path: "https://exercism.io/",
    cName: "icon",
    icon: exercism,
    description:
      "Code practice and mentorship for everyone Level up your programming skills with 3,424 exercises across 52 languages, and insightful discussion with our dedicated team of welcoming mentors. Exercism is 100% free forever.",
  },
  {
    title: "Spoj",
    path: "https://www.spoj.com/",
    cName: "icon",
    icon: spoj,
    description:
      "Become a true programming master Learn how to code and build efficient algorithms 26699145 submissions, 807621 registered users, 6819 public problems",
  },
];
